import React from 'react';

const Order = () => {
    return (
        <div className='container'>
            <div style={{height:"300px"}} className='card'>
                <h3 className='text-center'>Order Complete</h3>
            </div>
        </div>
    );
};

export default Order;